/* @flow */
import React from 'react';
import gql from 'graphql-tag';
import {DestinationMessage as DestinationMessageComponent} from '@homeaway/react-urgency-messaging';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';

export const fragments = {
    searchResult: gql`
        fragment DestinationMessageSearchResult on SearchResult {
            destinationMessage(assetVersion: 3) {
                iconTitleText {
                    title
                    message
                    icon
                    messageValueType
                    link {
                        linkText
                        linkHref
                    }
                }
                iconText {
                    message
                    icon
                    messageValueType
                }
            }
        }
    `
};

export function Content(destinationMessage: DestinationMessage) {
    return (
        <div data-wdio="DestinationMessage">
            <DestinationMessageComponent
                destinationMessage={destinationMessage}
                size={'l'}
                ariaHidden
                className={'UrgencyDestinationMessage--bordered'}
            />
        </div>
    );
}
